import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import Button from 'Components/Atoms/Button/Button';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import React, {useEffect, useMemo} from 'react';
import { SUBSTATUS } from 'Services/Status/Substatus.types';
import styles from './ActiveFilterBlocks.module.sass';

interface Props {
    metadata: any
    filters: any
    onDelete: any
    statusMapper: any
}

const ActiveFilterBlocks = ({
    metadata,
    filters,
    onDelete,
    statusMapper
}: Props) => {
    const activeFilterKeys = useMemo(() =>
        Object.keys(filters)
            ?.filter(i => !['query', 'type'].includes(i))
    , [filters]);

    useEffect(() => {
        console.log(metadata);
    }, [filters]);

    if (Object.keys(filters).length === 0) return <></>;

    return <>
        <div className={styles['header__filters']}>
            {
                activeFilterKeys
                    ?.map(i => {
                            let name = '';
                            let mediator = '';
                            let value: any = '';

                            switch (i) {
                                case 'status':
                                    name = 'Status';
                                    mediator = 'is gelijk aan';

                                    value = filters[i]
                                        ?.map((i: any, idx: number, array: any[]) =>
                                            <>{
                                                i === null
                                                    ? 'Geen waarde'
                                                    : statusMapper[i]
                                            }{idx !== array.length-1 && ', '}</>
                                        )
                                    break;
                                case 'updated_between':
                                    name = 'Aangepast';
                                    mediator = 'tussen';

                                    value = filters[i]?.[0].replaceAll(',', ' en ');
                                    break;
                                case 'created_between':
                                    name = 'Aangemaakt';
                                    mediator = 'tussen';

                                    value = filters[i]?.[0].replaceAll(',', ' en ');
                                    break;
                                case 'sent_at':
                                    name = 'Verzonden';
                                    mediator = 'tussen';

                                    value = filters[i]?.[0].replaceAll(',', ' en ');
                                    break;
                            }

                            return <div className={styles['header__filters-item']}>
                                <div className={styles['header__filters-item-title']}>
                                    { name }
                                </div>
                                <div className={styles['header__filters-item-operator']}>
                                    { mediator }
                                </div>
                                <div className={styles['header__filters-item-values']}>
                                    { value }
                                </div>
                                <div className={styles['header__filters-item-button']}>
                                    <Button
                                        variant='transparent'
                                        size='small'
                                        color='dark'
                                        iconBefore={<FontAwesomeIcon icon={faXmark} size={'lg'} />}
                                        onClick={() => onDelete(i)}
                                    />
                                </div>
                            </div>;
                        }
                    )
            }
        </div>
        <div className={styles['header__total']}>
            <div className={styles['header__total-strong']}>{ metadata?.total_filtered ?? '...' }</div> van de <div className={'header__total-strong'}>{ metadata?.total ?? 0 } </div> gevonden
        </div>
    </>
}

export default ActiveFilterBlocks;